import _classCallCheck from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
Copyright 2021 Splunk Inc.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
export var SplunkSpanAttributesProcessor = /*#__PURE__*/function () {
  function SplunkSpanAttributesProcessor(globalAttributes) {
    _classCallCheck(this, SplunkSpanAttributesProcessor);

    this._globalAttributes = globalAttributes !== null && globalAttributes !== void 0 ? globalAttributes : {};
  }

  _createClass(SplunkSpanAttributesProcessor, [{
    key: "setGlobalAttributes",
    value: function setGlobalAttributes(attributes) {
      if (attributes) {
        Object.assign(this._globalAttributes, attributes);
      } else {
        for (var _i = 0, _Object$keys = Object.keys(this._globalAttributes); _i < _Object$keys.length; _i++) {
          var key = _Object$keys[_i];
          delete this._globalAttributes[key];
        }
      }
    }
  }, {
    key: "getGlobalAttributes",
    value: function getGlobalAttributes() {
      return this._globalAttributes;
    }
  }, {
    key: "forceFlush",
    value: function forceFlush() {
      return Promise.resolve();
    }
  }, {
    key: "onStart",
    value: function onStart(span) {
      span.setAttribute('location.href', location.href);
      span.setAttributes(this._globalAttributes);
    }
  }, {
    key: "onEnd",
    value: function onEnd() {// Intentionally empty
    }
  }, {
    key: "shutdown",
    value: function shutdown() {
      return Promise.resolve();
    }
  }]);

  return SplunkSpanAttributesProcessor;
}();